interface ExcelOperationLoadingOptions<T> {
  setLoading: (loading: boolean) => void;
  operation: () => Promise<T>;
  message?: string;
  id?: string;
}

const waitForLoadingPaint = () =>
  new Promise<void>(resolve => {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => resolve());
      return;
    }

    setTimeout(resolve, 0);
  });

const setExcelOperationLoading = ({
  loading,
  id = 'default',
  message
}: {
  loading: boolean;
  id?: string;
  message?: string;
}) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent('excel-operation-loading', {
      detail: { loading, id, message }
    })
  );
};

export const runExcelOperationWithLoading = async <T>({
  setLoading,
  operation,
  message = 'Đang xử lý Excel...',
  id
}: ExcelOperationLoadingOptions<T>): Promise<T> => {
  setLoading(true);
  setExcelOperationLoading({ loading: true, id, message });
  await waitForLoadingPaint();

  try {
    return await operation();
  } finally {
    setExcelOperationLoading({ loading: false, id });
    setLoading(false);
  }
};
